var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TwitterPicker } from 'react-color';

import { COLORS } from "../../utils/colors";

class ColorPicker extends Component {
  constructor(props) {
    super(props);
    this.state = { active: false };
    this.onButtonClick = this.onButtonClick.bind(this);
    this.onBlur = this.onBlur.bind(this);
    this.onColorChange = this.onColorChange.bind(this);
  }

  onColorChange({ hex }) {
    const { onChange } = this.props;
    onChange(hex);
  }

  onButtonClick() {
    this.setState((oldState) => ({ active: !oldState.active }));
  }

  onBlur() {
    this.setState({ active: false });
  }

  render() {
    const { active } = this.state;
    const { value, defaultValue } = this.props;
    return /*#__PURE__*/(
      _jsx("div", { className: "ColorPicker" }, void 0, /*#__PURE__*/
      _jsx("div", {
        className: "ColorPicker__button",
        style: { backgroundColor: value || defaultValue },
        onClick: this.props.disabled ? () => {} : this.onButtonClick }),

      active && /*#__PURE__*/
      _jsx("div", { className: "ColorPicker__popover" }, void 0, /*#__PURE__*/
      _jsx("div", { className: "ColorPicker__cover", onClick: this.onBlur }), /*#__PURE__*/
      _jsx(TwitterPicker, {
        color: value || defaultValue,
        colors: COLORS,
        onChangeComplete: this.onColorChange }))));





  }
}

ColorPicker.defaultProps = {
  value: '',
  defaultValue: '',
  disabled: false
};








export default ColorPicker;